/**
 * useGetSpinWheelConfig — Fetch public segment display data for a spin wheel config
 *
 * GET /gamification-models/spin-wheel-config/:configId
 * Returns labels and colors only — probabilities are omitted server-side.
 * Used by WheelSpinRenderer to draw wheel segments.
 */
import {useQuery} from "@tanstack/react-query";
import getConfig from "@/utils/getConfig";
import {GamificationApi} from "@devour/client";

export function useGetSpinWheelConfig(configId?: string) {
    return useQuery({
        queryKey: ["spin-wheel-config", configId],
        queryFn: () =>
            new GamificationApi(getConfig()).getGamificationModelsSpinWheelConfigConfigId({configId: configId!}),
        staleTime: 5 * 60_000,
        enabled: Boolean(configId),
    });
}
